export const datadogIsEnabled = (host = window.location.hostname): boolean => {
  return host.includes('cardiologs.com');
};
